import {Action} from '../../actions/index';
import {ActionTypes, FetchPriceFulfilledPayload, FetchPricesFulfilledPayload, PricingState} from './types';
import {FailedRequestPayload} from '../types';

const initialState: PricingState = {
  loadingPrice: true,
  loadingBatchPrice: true,
  fetchedPrice: false,
  products: [],
  productsList: [{}],
  totalPrice: 0,
  priceError: null
};

const PricingReducer = (state: PricingState = initialState, action: Action): PricingState => {
  switch (action.type) {
    case ActionTypes.FETCH_PRODUCT_PACKAGE_PRICES_PENDING: {
      return {
        ...state,
        loadingPrice: true,
        loadingBatchPrice: true,
        fetchedPrice: false,
        priceError: null
      };
    }
    case ActionTypes.FETCH_PRODUCT_PACKAGE_PRICES_FULFILLED: {
      const {total, products} = action.payload as FetchPriceFulfilledPayload;
      const {data} = action.payload as FetchPricesFulfilledPayload;
      if (data) {
        return {
          ...state,
          productsList: data,
          loadingBatchPrice: false,
          fetchedPrice: true,
          priceError: null
        };
      } else {
        return {
          ...state,
          totalPrice: total,
          products,
          loadingPrice: false,
          fetchedPrice: true,
          priceError: null
        };
      }
    }
    case ActionTypes.FETCH_PRODUCT_PACKAGE_PRICES_REJECTED: {
      const {error} = action.payload as FailedRequestPayload;
      return {
        ...state,
        loadingPrice: false,
        loadingBatchPrice: false,
        fetchedPrice: false,
        priceError: error
      };
    }
    default: {
      return state;
    }
  }
};

export default PricingReducer;
